import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setPageTitle } from '../components/navigation/navbarUtils';
import utils from '../helpers/utils';
import userUtils from '../helpers/userUtils';

/**
 * Hook that sets the page title and logs page views
 * Uses the navigation structure from navbarUtils to determine titles
 *
 * This replaces the old UsePageViews hook with a more maintainable solution
 * that leverages the navigation structure from navbarUtils.tsx
 */
export default function usePageTitle(uid = utils.uid) {
	const location = useLocation();

	useEffect(() => {
		// Set the page title using our consolidated navigation structure
		setPageTitle(uid);

		// Log page views for debugging (same as original usePageViews)
		if (utils.isSuperAdmin() || userUtils.debugMode()) {
			console.info('Logging page view:', location.pathname + location.search);
		}

		// If analytics tracking is needed in the future, it can be added here
		// For example:
		// if (analytics) {
		//   analytics.pageview(location.pathname + location.search);
		// }
	}, [location]);

	return location;
}
